import type { DomainManifest } from 'modules/core/lib/manifests/types'
import type { Navigation, NavigationPaths } from 'modules/core/lib/navigation/context'

import { AnswerFormActivity } from 'modules/forms/activities/answerForm'
import { PreviewFormActivity } from 'modules/forms/activities/previewForm'
import { FormResponsesActivity } from 'modules/forms/activities/formResponses'

export const manifest = {
  sidebar: (_navigation: Navigation<NavigationPaths>) => ({
    items: [],
  }),
  activities: {
    answerForm: {
      component: AnswerFormActivity,
      guidelines:
        'Opens the answer form overlay so the user can fill out a form. Use when the user wants to fill out, answer, or complete a form.',
      params: {
        formId: { guidelines: 'The ID of the form to answer.' },
        membershipId: {
          guidelines: 'The ID of the membership context for the form (e.g. employee or company).',
        },
      },
    },
    previewForm: {
      component: PreviewFormActivity,
      guidelines:
        'Opens the form preview overlay to view and optionally submit a form without editing its definition. Use when the user wants to preview a form before publishing or review how a form looks.',
      params: {
        formId: { guidelines: 'The ID of the form to preview.' },
        resourceType: { guidelines: 'The type of resource the form is associated with.' },
        membershipId: {
          guidelines:
            'The ID of the membership context to scope the preview to a specific member. Optional.',
        },
      },
    },
    formResponses: {
      component: FormResponsesActivity,
      guidelines:
        'Opens the form responses overlay to view responses for a form. Use when the user wants to see form responses, view answers to a form, or check form submissions.',
      params: {
        formId: { guidelines: 'The ID of the form whose responses to show.' },
        membershipId: { guidelines: 'The ID of the membership context for the form.' },
      },
    },
  },
} as const satisfies DomainManifest
